import React from 'react';
import { Link } from 'react-router-dom';
import Icon from 'components/AppIcon';

const SuccessCard = ({ countdown, resetTime }) => {
  return (
    <div className="text-center">
      {/* Animated Success Icon */}
      <div className="relative w-20 h-20 mx-auto mb-6">
        <div className="w-20 h-20 bg-green-100 rounded-full flex items-center justify-center">
          <Icon name="ShieldCheck" size={40} className="text-green-600" />
        </div>
        <div className="absolute -top-1 -right-1 w-7 h-7 bg-green-500 rounded-full flex items-center justify-center border-2 border-surface">
          <Icon name="Check" size={14} color="white" />
        </div>
      </div>

      <h2 className="text-2xl font-heading font-bold text-text-primary mb-2">Password Reset Successful!</h2>
      <p className="text-text-secondary text-sm leading-relaxed mb-6">
        Your password has been updated successfully. Your old password is no longer valid.
      </p>

      {/* Timestamp */}
      <div className="flex items-center justify-center gap-2 text-xs text-text-secondary bg-background rounded-lg px-4 py-2.5 border border-border mb-6">
        <Icon name="Clock" size={14} className="text-primary" />
        <span>Password changed on <strong className="text-text-primary">{resetTime}</strong></span>
      </div>

      {/* CTA Button */}
      <Link
        to="/login"
        className="w-full bg-primary text-white py-3 px-4 rounded-lg font-medium hover:bg-primary-700 focus:outline-none focus:ring-2 focus:ring-primary focus:ring-offset-2 transition-smooth flex items-center justify-center gap-2 mb-4"
      >
        <Icon name="LogIn" size={18} />
        Continue to Login
      </Link>

      {/* Countdown */}
      <div className="flex items-center justify-center gap-2 text-sm text-text-secondary">
        <div className="w-6 h-6 rounded-full bg-primary/10 flex items-center justify-center">
          <span className="text-primary text-xs font-bold">{countdown}</span>
        </div>
        <span>Redirecting automatically in {countdown} second{countdown !== 1 ? 's' : ''}...</span>
      </div>
    </div>
  );
};

export default SuccessCard;
